<template>
    <div class="type-toggle">
        <label>
            <input type="radio" value="picture" v-model="localType" />
            Изображение
        </label>
        <label style="margin-left: 10px">
            <input type="radio" value="video" v-model="localType" />
            Видео
        </label>
    </div>
</template>

<script>
export default {
    name: 'Type',
    props: {
        type: {
            type: String,
            default: 'picture',
        },
    },
    emits: ['update:type'],
    data() {
        return {
            localType: this.type,
        };
    },
    watch: {
        localType(newVal) {
            this.$emit('update:type', newVal);
        },
        type(newVal) {
            this.localType = newVal;
        },
    },
};
</script>
